import { Modal } from '@/components/Elements';
import { Button } from '@/components/TSX components';
import Input from '@/components/Input';
import {
  CaretDown,
  CaretRight,
  Info,
  MagnifyingGlass,
  X,
  XCircle,
} from '@phosphor-icons/react';
import { useCallback, useEffect, useState } from 'react';
import { useGetTagsList } from '../api/dataCatalog/getDictionaryTagsList';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import { ClickAwayListener, Skeleton } from '@mui/material';
import Checkbox from '@/components/Checkbox';
import { useGetTablesList } from '../api/dataCatalog/getAllTables';
import { debounce, isEqual } from 'lodash';
import { isEmpty } from 'lodash';
import { EditColList } from './EditColList';
import { useUpdateColumnDetails } from '../api/dataCatalog/updateColumnDetails';
import { useGetTableObjColumn } from '../api/dataCatalog/getTableObjColumn';
import ToolTip from '@/components/Tooltip';
import { KDEntityTagModal } from './KDEntityTagModal';

const TagDropdown = ({
  list,
  listLoading,
  selected,
  setSelected,
  selectedColDetails,
  setEntityCurrColumn,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  function handleClick(event) {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  }

  const currTableObjCol = useGetTableObjColumn({
    tableId: selectedColDetails.sourceId || selectedColDetails.dDSourceId,
  });

  useEffect(() => {
    if (
      currTableObjCol.data?.col !== null &&
      currTableObjCol.data?.column?.name
    ) {
      setEntityCurrColumn({
        tableName: selectedColDetails.tableName,
        colToName: selectedColDetails.name,
        colFromName: currTableObjCol.data.column.name,
      });
    }
  }, [currTableObjCol.data]);

  return (
    <div
      style={{
        zIndex: 1,
      }}
    >
      <div className="flex h-full w-full items-center">
        <button
          className={`flex items-center justify-between gap-2 py-1 rounded-lg w-full border hover:border-pv-primary-primary-500 relative ${anchorEl ? `border-pv-primary-primary-500` : `border-pv-neutral-grey-200`}`}
          onClick={handleClick}
          style={{
            minHeight: '40px',
          }}
        >
          <span
            className="overflow-y-auto overflow-x-hidden flex pl-4 justify-between"
            style={{
              width: '618px',
              textAlign: 'start',
              lineHeight: '25px',
              maxHeight: '83px',
            }}
          >
            <p
              className="h-fit"
              style={{
                maxWidth: '550px',
              }}
            >
              {selected.length > 0 ? (
                selected.map((sel, ind) => {
                  return (
                    <span
                      className="inline-flex items-center text-xxs text-pv-text-primary-text"
                      style={{
                        height: '25px',
                      }}
                    >
                      {ind !== 0 && <span>&thinsp;&nbsp;|&nbsp;&thinsp;</span>}
                      <span className="inline-flex gap-1 items-center px-1.5 py-1 bg-pv-primary-primary-100 rounded-lg">
                        <span>{sel.name}</span>
                        <X
                          weight="bold"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelected((prev) => {
                              let temp = structuredClone(prev);
                              temp = temp.filter((tmp) => tmp.id !== sel.id);
                              temp.sort((a, b) => a.name.localeCompare(b.name));
                              return temp;
                            });
                          }}
                        />
                      </span>
                    </span>
                  );
                })
              ) : (
                <span className="text-pv-text-secondary-text">Select Tags</span>
              )}
            </p>
            <span
              className="flex h-fit w-fit absolute"
              style={{
                top: '50%',
                transform: 'translateY(-50%)',
                right: '16px',
                transition: 'none',
              }}
            >
              <CaretDown
                size={20}
                className={`${anchorEl ? `transform -rotate-180` : ``}`}
                style={{
                  transition: 'transform 0.3s ease',
                }}
              />
            </span>
          </span>
        </button>
      </div>
      <Popper
        open={anchorEl}
        anchorEl={anchorEl}
        placement="bottom-start"
        transition
        style={{
          zIndex: 2,
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener
            onClickAway={() => {
              setAnchorEl(null);
            }}
          >
            <Fade {...TransitionProps} timeout={250}>
              <div
                className="bg-white flex flex-col rounded-lg border border-brand-ai-gray-400 relative h-fit p-2"
                style={{
                  boxShadow: `0px 8px 24px 0px rgba(0, 0, 0, 0.10)`,
                  width: '618px',
                }}
              >
                <div className="flex flex-col w-full h-full">
                  <div className="flex flex-col h-full">
                    {listLoading
                      ? Array.from({ length: 5 }).map((_, index) => (
                          <div className="flex gap-2 p-2" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={index % 2 === 1 ? '35%' : '65%'}
                              height={20}
                              sx={{ bgcolor: '#EEF0F7' }}
                            />
                          </div>
                        ))
                      : list.map((elem, ind) => {
                          return (
                            <div
                              className={`flex items-center justify-between ${
                                selectedColDetails?.primary &&
                                elem.name === 'Object View'
                                  ? 'hover:bg-white cursor-not-allowed'
                                  : 'hover:bg-pv-primary-primary-50 cursor-pointer'
                              }`}
                            >
                              <Checkbox
                                label={elem.name}
                                key={ind}
                                disabled={
                                  selectedColDetails?.primary &&
                                  elem.name === 'Object View'
                                }
                                checked={
                                  selected.findIndex(
                                    (sel) => sel.name === elem.name
                                  ) > -1
                                }
                                className={{
                                  wrapper: `px-4 py-3 w-full flex gap-2 items-center ${
                                    selectedColDetails?.primary &&
                                    elem.name === 'Object View'
                                      ? `cursor-not-allowed text-t-disabled`
                                      : `cursor-pointer`
                                  }`,
                                  label: `${
                                    selectedColDetails?.primary &&
                                    elem.name === 'Object View'
                                      ? ` text-t-disabled`
                                      : ``
                                  }`,
                                }}
                                onChange={(e) => {
                                  if (e.checked) {
                                    setSelected((prev) => {
                                      let temp = structuredClone(prev);
                                      temp.push(elem);
                                      temp.sort((a, b) =>
                                        a.name.localeCompare(b.name)
                                      );
                                      return temp;
                                    });
                                  } else {
                                    setSelected((prev) => {
                                      let temp = structuredClone(prev);
                                      temp = temp.filter(
                                        (tmp) => tmp.id !== elem.id
                                      );
                                      temp.sort((a, b) =>
                                        a.name.localeCompare(b.name)
                                      );
                                      return temp;
                                    });
                                  }
                                }}
                              />
                              {elem.description && (
                                <ToolTip
                                  placement="top"
                                  title={elem.description}
                                >
                                  <Info
                                    size={16}
                                    className="text-pv-neutral-grey-500 hover:text-pv-text-primary-text cursor-pointer mr-2"
                                  />
                                </ToolTip>
                              )}
                            </div>
                          );
                        })}
                  </div>
                </div>
              </div>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  );
};

const CFDropdown = ({
  list,
  listLoading,
  selected,
  setSelected,
  selectedColDetails,
  table,
  setTable,
  searchQuery,
  setSearchQuery,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [immediateQuery, setImmediateQuery] = useState('');

  function handleClick(event) {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setTable({});
    setSearchQuery('');
    setImmediateQuery('');
  }

  let numList = {};
  if (selected.length > 0) {
    selected.forEach((sel) => {
      const temp = sel.tableId;
      if (numList[temp] === undefined) {
        numList[temp] = 1;
      } else {
        numList[temp] = numList[temp] + 1;
      }
    });
  }

  const searchDebounce = useCallback(
    debounce((e) => {
      setSearchQuery(e.target.value);
    }, 300),
    []
  );

  return (
    <div
      style={{
        zIndex: 1,
      }}
    >
      <div className="flex h-full w-full items-center">
        <button
          className={`flex items-center justify-between gap-2 py-1 rounded-lg w-full border hover:border-pv-primary-primary-500 relative ${anchorEl ? `border-pv-primary-primary-500` : `border-pv-neutral-grey-200`}`}
          onClick={handleClick}
          style={{
            minHeight: '40px',
          }}
        >
          <span
            className="overflow-y-auto overflow-x-hidden flex pl-4 justify-between"
            style={{
              width: '618px',
              textAlign: 'start',
              lineHeight: '25px',
              maxHeight: '83px',
            }}
          >
            <p
              className="h-fit"
              style={{
                maxWidth: '550px',
              }}
            >
              {selected.length > 0 ? (
                selected.map((sel, ind) => {
                  return (
                    <span
                      className="inline-flex items-center text-xxs text-pv-text-primary-text"
                      style={{
                        height: '25px',
                      }}
                    >
                      {ind !== 0 && <span>&thinsp;&nbsp;|&nbsp;&thinsp;</span>}
                      <span className="inline-flex gap-1 items-center px-1.5 py-1 bg-pv-primary-primary-100 rounded-lg">
                        <span>{sel.foreignField}</span>
                        <X
                          weight="bold"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelected((prev) => {
                              let temp = structuredClone(prev);
                              temp = temp.filter(
                                (tmp) =>
                                  !(
                                    tmp.tableId === sel.tableId &&
                                    tmp.foreignField === sel.foreignField
                                  )
                              );
                              temp.sort((a, b) => {
                                const str1 = a.foreignField + a.table;
                                const str2 = b.foreignField + b.table;
                                return str1.localeCompare(str2);
                              });
                              return temp;
                            });
                          }}
                        />
                      </span>
                    </span>
                  );
                })
              ) : (
                <span className="text-pv-text-secondary-text">
                  Select Connected Fields
                </span>
              )}
            </p>
            <span
              className="flex h-fit w-fit absolute"
              style={{
                top: '50%',
                transform: 'translateY(-50%)',
                right: '16px',
                transition: 'none',
              }}
            >
              <CaretDown
                size={20}
                className={`${anchorEl ? `transform -rotate-180` : ``}`}
                style={{
                  transition: 'transform 0.3s ease',
                }}
              />
            </span>
          </span>
        </button>
      </div>
      <Popper
        open={anchorEl}
        anchorEl={anchorEl}
        placement="bottom-start"
        transition
        style={{
          zIndex: 2,
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener
            onClickAway={() => {
              setAnchorEl(null);
              setTable({});
              setSearchQuery('');
              setImmediateQuery('');
            }}
          >
            <Fade {...TransitionProps} timeout={250}>
              <div
                className="bg-white flex flex-col rounded-lg border border-brand-ai-gray-400 relative h-fit p-2"
                style={{
                  boxShadow: `0px 8px 24px 0px rgba(0, 0, 0, 0.10)`,
                }}
              >
                <Input
                  leftElem={<MagnifyingGlass size={16} />}
                  rightElem={
                    immediateQuery.length > 0 && (
                      <XCircle
                        size={16}
                        onClick={() => {
                          setImmediateQuery('');
                          setSearchQuery('');
                        }}
                        className="mr-2 text-pv-neutral-grey-500 cursor-pointer hover:text-pv-text-primary-text"
                      />
                    )
                  }
                  className={{
                    input: {
                      wrapper: 'pr-0 py-2 m-0',
                    },
                  }}
                  value={immediateQuery}
                  onChange={(e) => {
                    setTable({});
                    setImmediateQuery(e.target.value);
                    searchDebounce(e);
                  }}
                  iconClassName="left-0 pl-4"
                  placeholder={`Search`}
                />
                <div
                  className="flex flex-col w-full h-full relative"
                  style={{
                    minWidth: '400px',
                    maxHeight: '180px',
                  }}
                >
                  <div className="flex flex-col h-full overflow-y-scroll mt-1">
                    {listLoading ? (
                      Array.from({ length: 5 }).map((_, index) => (
                        <div className="flex gap-2 p-2" key={index}>
                          <Skeleton
                            variant="rounded"
                            width={index % 2 === 1 ? '35%' : '65%'}
                            height={20}
                            sx={{ bgcolor: '#EEF0F7' }}
                          />
                        </div>
                      ))
                    ) : list.length === 0 ? (
                      <>
                        <span className="text-pv-text-secondary-text p-1">
                          No Tables Found
                        </span>
                        <div className="w-fit">
                          <Button
                            btnColor="secondary"
                            btnSize="sm"
                            onClick={() => {
                              setImmediateQuery('');
                              setSearchQuery('');
                            }}
                          >
                            Clear Search
                          </Button>
                        </div>
                      </>
                    ) : (
                      list.map((elem, ind) => {
                        return (
                          <div
                            className="flex px-4 py-3 justify-between items-center hover:bg-pv-primary-primary-50 cursor-pointer"
                            onClick={() => {
                              setTable((prev) =>
                                isEqual(prev, elem) ? {} : elem
                              );
                            }}
                            key={ind}
                          >
                            <span
                              className="text-sm overflow-ellipsis overflow-hidden"
                              style={{
                                maxWidth: '300px',
                              }}
                            >
                              {elem.name}
                            </span>
                            <div className="flex items-center gap-1">
                              {numList[elem.id] !== undefined && (
                                <span className="text-xxs text-white bg-pv-primary-primary-500 px-1.5 py-1 rounded-md">
                                  {numList[elem.id]}
                                </span>
                              )}
                              <CaretRight />
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                  {!isEmpty(table) && (
                    <div
                      className="absolute"
                      style={{
                        left: 'calc(100% + 10px)',
                      }}
                    >
                      <EditColList
                        table={table}
                        selected={selected}
                        setSelected={setSelected}
                        selectedColDetails={selectedColDetails}
                        searchQuery={searchQuery}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  );
};

export const EditColumnDetailModal = ({
  isOpen,
  handleCloseModal,
  selectedColDetails,
  setBkpSources,
  setSources,
}) => {
  const handleCloseModalHandler = () => {
    handleCloseModal();
  };

  const [searchQuery, setSearchQuery] = useState('');

  const tagList = useGetTagsList({ keyword: '' });

  const tablesListData = useGetTablesList({
    columnNameKeyword: searchQuery,
    config: {
      staleTime: Infinity,
    },
  });

  const [form, setForm] = useState({
    label: '',
    desc: '',
  });
  const [tags, setTags] = useState([]);
  const [connFlds, setConnFlds] = useState([]);
  const [table, setTable] = useState({});

  const [objModalOpen, setObjModalOpen] = useState(false);
  const [entityCurrColumn, setEntityCurrColumn] = useState({
    tableName: '',
    colFromName: '',
    colToName: '',
  });

  const updateColDetails = useUpdateColumnDetails();

  useEffect(() => {
    setForm({
      label: selectedColDetails.label || '',
      desc: selectedColDetails.description || '',
    });
    if (Array.isArray(selectedColDetails?.tags)) {
      let temp = selectedColDetails.tags.map((tag) => ({
        id: tag._id || tag.id,
        name: tag.name,
        ...(tag.description && { description: tag.description }),
      }));
      temp.sort((a, b) => a.name.localeCompare(b.name));
      setTags(temp);
    }
    if (Array.isArray(selectedColDetails?.mappings)) {
      let temp = selectedColDetails.mappings.map((cf) => ({
        foreignField: cf.foreignField,
        localField: cf.localField,
        table: cf.table,
        tableId: cf.tableId,
      }));
      temp.sort((a, b) => {
        const str1 = a.foreignField + a.table;
        const str2 = b.foreignField + b.table;
        return str1.localeCompare(str2);
      });
      setConnFlds(temp);
    }
  }, [selectedColDetails]);

  let initTagList = [];
  if (Array.isArray(selectedColDetails?.tags)) {
    initTagList = selectedColDetails.tags.map((tag) => ({
      id: tag._id,
      name: tag.name,
      ...(tag.description && { description: tag.description }),
    }));
  }
  initTagList.sort((a, b) => a.name.localeCompare(b.name));

  let initCFList = [];
  if (Array.isArray(selectedColDetails?.mappings)) {
    initCFList = selectedColDetails.mappings.map((cf) => ({
      foreignField: cf.foreignField,
      localField: cf.localField,
      table: cf.table,
      tableId: cf.tableId,
    }));
  }
  initCFList.sort((a, b) => {
    const str1 = a.foreignField + a.table;
    const str2 = b.foreignField + b.table;
    return str1.localeCompare(str2);
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setTable({});
        handleCloseModalHandler();
      }}
      topStripClassName="hidden"
      topBorderClassname="border-t-5 border-pv-primary-primary-500"
      className="relative w-fit"
      showHeader={false}
    >
      <div
        className="relative"
        style={{
          zIndex: 1,
        }}
      >
        <div
          className="flex flex-col justify-between"
          style={{
            zIndex: 1,
          }}
        >
          <div
            className="flex w-full justify-between p-4 items-center"
            style={{
              width: '650px',
            }}
          >
            <span className="text-base font-medium flex gap-2">
              <span
                className="overflow-ellipsis overflow-hidden whitespace-nowrap"
                style={{
                  maxWidth: '300px',
                }}
              >
                Edit {selectedColDetails.name}
              </span>
              <span className="text-xs py-1 px-2 bg-pv-tags-blue font-normal rounded-lg">
                {selectedColDetails.type}
              </span>
            </span>
            <div className="flex items-center gap-2">
              <X
                size={16}
                className="cursor-pointer"
                onClick={() => {
                  handleCloseModalHandler();
                }}
              />
            </div>
          </div>
          <div className="flex flex-col w-full p-4 gap-6">
            <div className="text-sm flex flex-col gap-2 text-brand-ai-200">
              <div>Field name</div>
              <Input
                className={{
                  input: {
                    wrapper: `pr-0 py-2 m-0`,
                  },
                }}
                value={form.label}
                onChange={(e) => setForm({ ...form, label: e?.target.value })}
                placeholder="Enter field name"
              />
            </div>
            <div className="text-sm flex flex-col gap-2 text-brand-ai-200">
              <div>Description</div>
              <Input
                type="textarea"
                className={{
                  input: {
                    wrapper: `pr-0 py-2 m-0`,
                  },
                }}
                value={form.desc}
                labelTextClassName="text-sm flex flex-col gap-2 text-brand-ai-200"
                placeholder="Enter the description"
                onChange={(e) => setForm({ ...form, desc: e?.target.value })}
                minRows={3}
                maxRows={3}
              />
            </div>
            {(selectedColDetails?.sourceId ||
              selectedColDetails?.dDSourceId) && (
              <div className="w-full gap-2 flex flex-col">
                <div>Tags</div>
                <TagDropdown
                  list={tagList.data?.data}
                  listLoading={tagList.isLoading}
                  selected={tags}
                  setSelected={setTags}
                  selectedColDetails={selectedColDetails}
                  setEntityCurrColumn={setEntityCurrColumn}
                />
              </div>
            )}
            <div className="w-full gap-2 flex flex-col">
              <div>Connected Fields</div>
              <CFDropdown
                list={tablesListData.data?.data}
                listLoading={tablesListData.isLoading}
                selected={connFlds}
                setSelected={setConnFlds}
                searchQuery={searchQuery}
                selectedColDetails={selectedColDetails}
                table={table}
                setTable={setTable}
                setSearchQuery={setSearchQuery}
              />
            </div>
          </div>
          <div className="border-t border-pv-neutral-grey-100 mt-2 w-full">
            <div className="flex justify-between items-center p-4">
              <Button
                btnColor="ghost"
                onClick={() => {
                  setTable({});
                  handleCloseModalHandler();
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  const oVTagInd = tags.findIndex(
                    (tag) => tag.name === 'Object View'
                  );
                  const initialOVTagPresent = selectedColDetails.tags.findIndex(
                    (tag) => tag.name === 'Object View'
                  );
                  if (oVTagInd === -1) {
                    let selTags = tags.map((tag) => tag.id);
                    let selConnFlds = connFlds.map((fld) => ({
                      foreignField: fld.foreignField,
                      table: fld.table,
                      tableId: fld.tableId,
                    }));
                    const data = {
                      label: form.label,
                      description: form.desc,
                      tags: selTags,
                      mappings: selConnFlds,
                    };
                    await updateColDetails.mutateAsync({
                      integId:
                        selectedColDetails.integrationId ||
                        selectedColDetails.tableDetails.integrationId,
                      tableId:
                        selectedColDetails.sourceId ||
                        selectedColDetails.dDSourceId,
                      columnName: selectedColDetails.name,
                      searchQuery: searchQuery,
                      data: data,
                    });
                    setBkpSources((prev) => {
                      let temp = structuredClone(prev);
                      temp[selectedColDetails.tableId].forEach((col, index) => {
                        if (col.name === selectedColDetails.name) {
                          let tempCol = structuredClone(col);
                          tempCol.description = form.desc;
                          tempCol.label = form.label;
                          tempCol.tags = tags;
                          tempCol.mappings = connFlds;
                          temp[selectedColDetails.tableId][index] = tempCol;
                        }
                      });
                      setSources(temp);
                      return temp;
                    });
                    setTable({});
                    handleCloseModalHandler();
                  } else {
                    if (initialOVTagPresent === -1) {
                      setObjModalOpen(true);
                    } else {
                      let selTags = tags.map((tag) => tag.id);
                      let selConnFlds = connFlds.map((fld) => ({
                        foreignField: fld.foreignField,
                        table: fld.table,
                        tableId: fld.tableId,
                      }));
                      const data = {
                        label: form.label,
                        description: form.desc,
                        tags: selTags,
                        mappings: selConnFlds,
                      };
                      await updateColDetails.mutateAsync({
                        integId:
                          selectedColDetails.integrationId ||
                          selectedColDetails.tableDetails.integrationId,
                        tableId:
                          selectedColDetails.sourceId ||
                          selectedColDetails.dDSourceId,
                        columnName: selectedColDetails.name,
                        searchQuery: searchQuery,
                        data: data,
                      });
                      setBkpSources((prev) => {
                        let temp = structuredClone(prev);
                        temp[selectedColDetails.tableId].forEach(
                          (col, index) => {
                            if (col.name === selectedColDetails.name) {
                              let tempCol = structuredClone(col);
                              tempCol.description = form.desc;
                              tempCol.label = form.label;
                              tempCol.tags = tags;
                              tempCol.mappings = connFlds;
                              temp[selectedColDetails.tableId][index] = tempCol;
                            }
                          }
                        );
                        setSources(temp);
                        return temp;
                      });
                      setTable({});
                      handleCloseModalHandler();
                    }
                  }
                }}
                disabled={
                  form.label === selectedColDetails.label &&
                  form.desc === selectedColDetails.description &&
                  isEqual(initTagList, tags) &&
                  isEqual(initCFList, connFlds)
                }
              >
                Save
              </Button>
            </div>
          </div>
        </div>
        <div
          className="absolute top-0 left-0"
          style={{
            zIndex: 2,
          }}
        >
          <KDEntityTagModal
            isOpen={objModalOpen}
            handleCloseModal={() => {
              setObjModalOpen(false);
            }}
            entityCurrColumn={entityCurrColumn}
            tags={tags}
            connFlds={connFlds}
            form={form}
            selectedColDetails={selectedColDetails}
            searchQuery={searchQuery}
            closeMainModal={handleCloseModalHandler}
            setTable={setTable}
            setBkpSources={setBkpSources}
            setSources={setSources}
          />
        </div>
      </div>
    </Modal>
  );
};
